var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlightticket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 57.5V52.5H57.5V57.5H12.5ZM17.125 45L10 32.875L13.875 32.125L18.25 36L30.25 32.75L20.125 15.625L25 14.125L42.125 29.5L54.625 26.125C55.9583 25.75 57.1667 26 58.25 26.875C59.3333 27.75 59.875 28.9167 59.875 30.375C59.875 31.2917 59.5938 32.1042 59.0312 32.8125C58.4688 33.5208 57.75 34 56.875 34.25L17.125 45Z",
    fill: "#031273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightticket);
export default __webpack_public_path__ + "static/media/flightticket.62af3f1625c799dde47be7bc766f14d0.svg";
export { ForwardRef as ReactComponent };